/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./init-assets (ignored)
// module id = 894
// module chunks = 0